var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25110_535)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25110_535",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.767212,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25110_535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2672 10C10.3047 10 9.4808 9.65733 8.79546 8.972C8.10996 8.2865 7.76721 7.4625 7.76721 6.5C7.76721 5.5375 8.10996 4.71358 8.79546 4.02825C9.4808 3.34275 10.3047 3 11.2672 3C12.2297 3 13.0536 3.34275 13.739 4.02825C14.4245 4.71358 14.7672 5.5375 14.7672 6.5C14.7672 7.4625 14.4245 8.2865 13.739 8.972C13.0536 9.65733 12.2297 10 11.2672 10ZM11.2672 8.5C11.8172 8.5 12.288 8.30417 12.6797 7.9125C13.0714 7.52083 13.2672 7.05 13.2672 6.5C13.2672 5.95 13.0714 5.47917 12.6797 5.0875C12.288 4.69583 11.8172 4.5 11.2672 4.5C10.7172 4.5 10.2464 4.69583 9.85471 5.0875C9.46305 5.47917 9.26721 5.95 9.26721 6.5C9.26721 7.05 9.46305 7.52083 9.85471 7.9125C10.2464 8.30417 10.7172 8.5 11.2672 8.5ZM3.76721 17.6155V15.4078C3.76721 14.9116 3.89771 14.4555 4.15871 14.0395C4.41955 13.6235 4.77755 13.3001 5.23271 13.0693C6.01855 12.6744 6.96563 12.3238 8.07396 12.0175C9.18229 11.711 10.396 11.5834 11.7152 11.6347C11.5665 11.8706 11.4375 12.1134 11.328 12.3632C11.2186 12.6132 11.1317 12.8723 11.0672 13.1405C9.97105 13.1533 8.97363 13.2985 8.07496 13.576C7.1763 13.8535 6.46346 14.1307 5.93646 14.4078C5.72496 14.5103 5.56055 14.6508 5.44321 14.8295C5.32588 15.0082 5.26721 15.2009 5.26721 15.4078V16.1155H10.952C11.0096 16.3795 11.0885 16.6381 11.1885 16.8913C11.2885 17.1446 11.4064 17.386 11.5422 17.6155H3.76721Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2133 17.0095V12.7194L13.6899 14.2428L12.6797 13.2483L15.9242 10L19.1688 13.2483L18.1586 14.2428L16.6352 12.7194V17.0095H15.2133ZM19.6892 21.7541L16.4447 18.5058L17.4549 17.5112L18.9783 19.0347V14.7445H20.4002V19.0347L21.9236 17.5112L22.9338 18.5058L19.6892 21.7541Z",
    fill: "#587E85"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25110_535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.767212)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOwner);
export default __webpack_public_path__ + "static/media/switch_owner.ff4be7e57b9f4fedfe8b661dfab9b590.svg";
export { ForwardRef as ReactComponent };